const validate_ = (verStr) => {
  const semverRegex = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
  return semverRegex.test(verStr);
};
const compare_ = (ver1, ver2) => {
  const parseVersion = (version) => version.split(".").map(Number);
  const [major1, minor1, patch1] = parseVersion(ver1);
  const [major2, minor2, patch2] = parseVersion(ver2);
  if (major1 > major2) return 1;
  if (major1 < major2) return -1;
  if (minor1 > minor2) return 1;
  if (minor1 < minor2) return -1;
  if (patch1 > patch2) return 1;
  if (patch1 < patch2) return -1;
  return 0;
};
const gt_ = (ver1, ver2) => compare_(ver1, ver2) === 1;
const gte_ = (ver1, ver2) => compare_(ver1, ver2) >= 0;
const lt_ = (ver1, ver2) => compare_(ver1, ver2) === -1;
const lte_ = (ver1, ver2) => compare_(ver1, ver2) <= 0;
const eq_ = (ver1, ver2) => compare_(ver1, ver2) === 0;
const semver = {
  validate: validate_,
  compare: compare_,
  gt: gt_,
  gte: gte_,
  lt: lt_,
  lte: lte_,
  eq: eq_
};
const semver$1 = semver;
export {
  semver$1 as default
};
